var qaTemplate = require("@/modules/components/qa.handlebars");
var qaModalTemplate = require("@/modules/components/qa-modal.handlebars");
var qaThankResponseModalTemplate = require("@/modules/components/thank-response-modal.handlebars");
var qaMinimizedTemplate = require("@/modules/components/qa-minimized.handlebars");
import TickIcon from "@/assets/media/icons/tick.svg";
import ChevronUpIcon from "@/assets/media/icons/chevron-up.svg";

const helper = require("@/helpers/index.js");

class LoraQuestionAndAnswer {
	constructor(
		parentElement,
		data,
		wrapLayout = ".lora-short__overlay__mid-left"
	) {
		this._parentElement = parentElement;
		this._data = data;
		this._wrapLayout = wrapLayout;
		this._clickedAnswerBtnCallback = null;
		this._answeredCallback = null;
		this._answeredQuestionCallback = null;
		this.clickOutsideDirective = helper.detectClickOutside();
		this._showingModal = false;
		this.answerValue = "";
		this.tickIcon = TickIcon;
		this.minimizeIcon = ChevronUpIcon;
		this._finishQACallback = null;
		this._isAnswering = false;
		this.renderQaMinimizedLayout();
	}

	set clickedAnswerBtnCallback(value) {
		this._clickedAnswerBtnCallback = value;
	}

	get clickedAnswerBtnCallback() {
		return this._clickedAnswerBtnCallback;
	}

	set answeredQuestionCallback(value) {
		this._answeredQuestionCallback = value;
	}

	get answeredQuestionCallback() {
		return this._answeredQuestionCallback;
	}

	get context() {
		return {
			bgColor: this._data.bgColor,
			textColor: this._data.textColor,
			shouldShowFollowUpQuestion: this._data.shouldShowFollowUpQuestion,
			questionFollowup: this._data.questionFollowup,
			questionDefault: this._data.questionDefault,
			submitted: this._data.submitted,
			tickIcon: this.tickIcon,
			minimizeIcon: this.minimizeIcon,
		};
	}

	async renderQaMinimizedLayout() {
		const wrapLayout = this._parentElement.querySelector(this._wrapLayout);
		const template = document.createElement("template");
		template.innerHTML = `${qaMinimizedTemplate(this.context)}`;
		wrapLayout.innerHTML = "";
		await wrapLayout.appendChild(template.content.cloneNode(true));

		this._parentElement
			.querySelector(".lora-qa__btn-minimized")
			.addEventListener("click", (event) => {
				event.stopPropagation();
				this.renderLayout();
				if (this._isAnswering) {
					this.renderQaModalLayout();
				}
			});
	}

	async renderLayout() {
		const wrapLayout = this._parentElement.querySelector(this._wrapLayout);
		const template = document.createElement("template");
		template.innerHTML = `${qaTemplate(this.context)}`;
		wrapLayout.innerHTML = "";
		await wrapLayout.appendChild(template.content.cloneNode(true));
		helper.appendCommonStyling(wrapLayout);
		this.registerEvents();
	}

	renderQaModalLayout() {
		const loraModalWrapper =
			this._parentElement.querySelector(".lora-qa__modal");
		const loraPreviewWrapper =
			this._parentElement.querySelector(".lora-qa__preview");
		loraModalWrapper.innerHTML = `${qaModalTemplate(this.context)}`;
		helper.appendCommonStyling(loraModalWrapper);
		this._qaLayout.classList.add("modal");
		loraPreviewWrapper.classList.add("lora--d-none");
		loraModalWrapper.classList.remove("lora--d-none");
		if (typeof this._clickedAnswerBtnCallback === "function") {
			this._clickedAnswerBtnCallback();
		}
		this._showingModal = true;
		this.registerQnAModalEvents();
	}

	registerEvents() {
		let answerBtn = this._parentElement.querySelector(".lora-qa--answer");
		this._qaLayout = this._parentElement.querySelector(".lora-qa");
		answerBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			this._isAnswering = true;
			this.renderQaModalLayout();
		});
		this._parentElement
			.querySelector(".lora-qa__btn-minimized")
			.addEventListener("click", (event) => {
				event.stopPropagation();
				this.renderQaMinimizedLayout();
			});
	}

	registerQnAModalEvents() {
		let sendBtn = this._parentElement.querySelector(".lora-qa--send");
		let answerInput = this._parentElement.querySelector(".lora-qa__default-qs");

		answerInput.value = this.answerValue;
		if (this.answerValue) {
			sendBtn.classList.remove("lora--disable");
		} else {
			sendBtn.classList.add("lora--disable");
		}
		answerInput.addEventListener("click", (event) => {
			event.stopPropagation();
			this.disableZoom();
		});
		// Disable zooming when the text area receives focus
		answerInput.addEventListener("focus", () => {
			this.disableZoom();
		});

		// Enable zooming when the text area loses focus
		answerInput.addEventListener("blur", () => {
			this.enableZoom();
		});

		answerInput.addEventListener("keyup", () => {
			this.answerValue = answerInput.value;
			if (this.answerValue) {
				sendBtn.classList.remove("lora--disable");
			} else {
				sendBtn.classList.add("lora--disable");
			}
		});
		sendBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			if (typeof this._answeredQuestionCallback === "function") {
				this._answeredQuestionCallback(
					encodeURIComponent(
						this.answerValue
							.replace(/</g, "")
							.replace(/>/g, "")
							.replace(/\bscript\b/g, "")
					)
				);
			}
			this.answerValue = "";
			if (this._data.shouldShowFollowUpQuestion) {
                this._isAnswering = false;
				this._data.submitted = true;
			} else {
				this._data.shouldShowFollowUpQuestion = true;
			}
		});

		this._parentElement
			.querySelector(".lora-qa__btn-minimized-modal")
			.addEventListener("click", (event) => {
				event.stopPropagation();
				this.renderQaMinimizedLayout();
			});
	}

	// Disable zooming on the entire page
	disableZoom() {
		document.body.style.zoom = "reset";
	}

	// Enable zooming on the entire page
	enableZoom() {
		document.body.style.zoom = "";
	}

	showThankModal() {
		const loraModalWrapper =
			this._parentElement.querySelector(".lora-qa__modal");
		const loraPreviewWrapper =
			this._parentElement.querySelector(".lora-qa__preview");
		loraModalWrapper.innerHTML = `${qaThankResponseModalTemplate(
			this.context
		)}`;
		helper.appendCommonStyling(loraModalWrapper);
		this._qaLayout.classList.add("modal");
		loraPreviewWrapper.classList.add("lora--d-none");
		loraModalWrapper.classList.remove("lora--d-none");

		this._showingModal = true;

		setTimeout(() => {
			this._qaLayout.classList.remove("modal");
			// this._qaLayout.classList.add('lora--d-none')
			this._parentElement
				.querySelector(".lora-qa--submitted")
				.classList.remove("lora--d-none");
			this._parentElement
				.querySelector(".lora-qa--answer")
				.classList.add("lora--d-none");
			loraPreviewWrapper.classList.remove("lora--d-none");
			loraModalWrapper.classList.add("lora--d-none");
		}, 3 * 1000);
		//Callback to update interacting status for short video
		this._finishQACallback();
	}

	showFollowUpQuestion() {
		// reset text-area
		let answerInput = this._parentElement.querySelector(".lora-qa__default-qs");
		answerInput.value = "";

		// Update question title
		let qaTitle = this._parentElement.querySelector(
			".lora-qa__modal .lora-qa__title"
		);
		qaTitle.innerHTML = this._data.questionFollowup;
	}

	syncStateOpenModal() {
		// Open modal QA input and sync state
		this._qaLayout = this._parentElement.querySelector(".lora-qa");
		const loraModalWrapper =
			this._parentElement.querySelector(".lora-qa__modal");
		const loraPreviewWrapper =
			this._parentElement.querySelector(".lora-qa__preview");
		loraModalWrapper.innerHTML = `${qaModalTemplate(this.context)}`;
		this._qaLayout.classList.add("modal");
		loraPreviewWrapper.classList.add("lora--d-none");
		loraModalWrapper.classList.remove("lora--d-none");
		loraModalWrapper.innerHTML = `${qaModalTemplate(this.context)}`;

		if (typeof this._clickedAnswerBtnCallback === "function") {
			this._clickedAnswerBtnCallback();
		}
		this._showingModal = true;
		this.registerQnAModalEvents();
	}
}

export default LoraQuestionAndAnswer;
